// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"66eaabe6","498":"ba9cb800","513":"34295ece","550":"0386e79e","589":"f76cd376","703":"2c756aaa","875":"ee972b60","961":"68d48ec8"}[chunkId] + ".chunk.js";
};